import React from 'react'
import styled from 'styled-components'

import { colors } from '../utils/style-utils'

const Title = styled.h2`
  font-weight: bold;
  font-size: 1rem;
  letter-spacing: 0.12em;
  text-align: center;
  text-transform: uppercase;
  position: relative;
  color: ${colors.white};

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 8em;
    height: 8em;
    background: ${colors.black};
    background-position: center;
    z-index: -1;
    transform: translateX(-50%) translateY(-50%) rotate(50grad);
  }

  span {
    display: block;
  }
`

const TileTitle = props => {
  const { children } = props
  return (
    <Title>
      {children
        .split(' ')
        .map((word, index) => <span key={index}>{word}</span>)}
    </Title>
  )
}

export default TileTitle



// WEBPACK FOOTER //
// ./src/components/TileTitle.js